const ListLineSvg = ({
  width = 16,
  height = 12,
  viewBox = '0 0 16 12',
}: {
  height?: number | string;
  width?: number | string;
  viewBox?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M5 11H15M5 6H15M5 1H15M1.00195 11V11.002L1 11.002V11H1.00195ZM1.00195 6V6.002L1 6.00195V6H1.00195ZM1.00195 1V1.002L1 1.00195V1H1.00195Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ListLineSvg;
